import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  INBOX_FILTER,
  INBOX_SEGMENTS,
} from "./actionTypes"

import {
  inboxFilterSuccess,
  inboxFilterError,
  inboxSegmentsSuccess,
  inboxSegmentsError,
} from "./actions"

import {
  apiGetInboxFilter,
  apiPostInboxSegments,
} from "../../api/calls/inbox"

function* inboxFilter({payload: data}) {
  try {
    const response = yield call(apiGetInboxFilter, data)
    yield put(inboxFilterSuccess(response))
  } catch (error) {
    yield put(inboxFilterError(error))
  }
}

function* inboxSegments({payload: data}) {
  try {
    const response = yield call(apiPostInboxSegments, data)
    yield put(inboxSegmentsSuccess(response))
  } catch (error) {
    yield put(inboxSegmentsError(error))
  }
}

export function* watchInboxFilter() {
  yield takeEvery(INBOX_FILTER, inboxFilter);
}

export function* watchInboxSegments() {
  yield takeEvery(INBOX_SEGMENTS, inboxSegments);
}

function* inboxSaga() {
  yield all([
    fork(watchInboxFilter),
    fork(watchInboxSegments),
  ]);
}

export default inboxSaga
